import { useEffect, useRef, useState } from 'react';
import QuoteWin from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWin';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import QuoteWinSimple from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinSimple';

export const OPEN_QUOTE_WIN_KEY = 'OPEN_QUOTE_WIN_KEY';

const FreeQuote: React.FC = () => {
    const { t } = useLang('powerbackup');

    /** 动画 */
    const titleRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (window.innerWidth >= 1024) return;
        setTimeout(() => {
            if (!titleRef.current) return;
            titleRef.current.classList.add('close');
        }, 6000);
    }, []);

    const [show, setShow] = useState(false);
    useEffect(() => {
        EcoDesignEventsBus.on('OPEN_QUOTE_WIN_KEY', (e) => {
            setShow(e);
        });
    }, []);

    return (
        <>
            <div
                className={`FreeQuote ${css.section} GtmModuleData-btn-common Widgets-box-in2-item`}
                data-btn-id="GAQ_Btn_Action"
                onClick={() => {
                    setShow(true);
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'floating_button',
                        button_name: 'GAQ_Btn_Action',

                        __btn_id1: 'power-backup .FreeQuote',
                        __btn_id2: 'GAQ_Btn_Action',
                        __btn_type: 'common',
                    });
                }}
            >
                <div className="title" ref={titleRef}>
                    <span>{t('secA_btn2')}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                        <path
                            d="M5.78088 11.2266L9.95764 8.23535L5.78088 5.24381L6.55725 4.15983L11.4908 7.69336C11.6655 7.81856 11.7692 8.02042 11.7692 8.23535C11.7691 8.45028 11.6656 8.65218 11.4908 8.77734L6.55725 12.3105L5.78088 11.2266Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div className="action-button"></div>
            </div>
            {show && <QuoteWinSimple callback={() => setShow(false)} />}
        </>
    );
};

export default FreeQuote;
